import { Flex } from '@change-corgi/design-system-legacy/layout';

import { Separator } from 'src/app/pages/petitionGamma/details/shared/components';

import { usePetitionDetails } from '../../../../hooks/petitionDetails';
import { ScrollTrackingWaypointContainer } from '../../../ScrollTrackingWaypoint';
import { useSignaturesDistributionContext } from '../../shared/provider';
import { SignatureDistributionSummary } from '../SignatureDistributionSummary';
import { SignatureMap } from '../SignatureMap';

type Props = {
	isStaff: boolean;
};

export function SignaturesDistributionInfo({ isStaff }: Props): React.JSX.Element | null {
	const { id } = usePetitionDetails();
	const {
		data: { isLoadingData, isCrunchingData, signaturesClusters, clusterPercentage },
	} = useSignaturesDistributionContext();

	return (
		<>
			{!isLoadingData && !isCrunchingData && signaturesClusters && clusterPercentage !== undefined && (
				<Flex sx={{ flexDirection: ['column'] }} mt={16} mb={8}>
					<ScrollTrackingWaypointContainer
						name="petition_sign_map_view"
						trackingData={{ petition_id: id, is_staff: isStaff }}
					/>
					<SignatureMap
						signaturesClusters={signaturesClusters}
						clusterPercentage={clusterPercentage}
						isStaff={isStaff}
					/>
					<Separator />
					<SignatureDistributionSummary signaturesClusters={signaturesClusters} clusterPercentage={clusterPercentage} />
				</Flex>
			)}
		</>
	);
}
